import { createContext, useContext } from "react";

import type { usePopoverContextValue } from "./usePopoverContextValue";

type PopoverContextValue = ReturnType<typeof usePopoverContextValue>;

export const PopoverContext = createContext<PopoverContextValue | undefined>(
  undefined
);

export const usePopoverContext = () => {
  const context = useContext(PopoverContext);

  if (!context) {
    throw new Error("PopoverContext not found");
  }

  return context;
};
